module.exports = __webpack_public_path__ + "img/acount_down_code.80d3c15b.png";